module.exports = __webpack_public_path__ + "static/media/What-This-Series-Is-About.ad41ab73.md";